/** @format */

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { Calendar } from "react-date-range";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import React, { useEffect, useState } from "react";

export default function SingleDateSelectDialog(props) {
  const { open, onClose, date, setDate } = props;
  const [displayDate, setDisplayDate] = useState(new Date());

  const handleClose = (newData) => {
    if (newData) {
      setDate(displayDate);
    }
    onClose();
  };

  useEffect(() => {
    setDisplayDate(date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog maxWidth={"sm"} open={open} onClose={() => handleClose(false)}>
      <DialogTitle>Change Date</DialogTitle>
      <DialogContent>
        <Calendar
          date={displayDate}
          onChange={(value) => {
            setDisplayDate(value);
          }}
          show
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            handleClose(true);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
